import { numberMoney, dateShortWithMonth } from 'Data/format.js'

export function getAmount(item) {
  return numberMoney(Math.abs(item.amount))
}

export function getName(payment_plan) {
  let rollback = ''
  if (payment_plan.payment_plan_rollback_id) {
    if (payment_plan.rollback_date) {
      rollback = ` (rolled back on ${dateShortWithMonth(new Date(`${payment_plan.rollback_date}Z`))})`
    } else {
      rollback = ' (rolled back)'
    }
  }

  return `Payment plan${rollback}`
}
